import {RetryConfig} from 'rxjs';

export const RETRY_STRATEGY_CONST: RetryConfig = {count: 0, delay: 500};
